import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OptionButton } from 'components';
import './styles.css';

const ClinicButton = ({ clinic, isSelected}) => {
  const { address, name } = clinic;
  const { street, city, state } = address;
  return (
    <div className="clinic__button">
      <img alt="" className="clinic__marker" src={isSelected ? require('assets/icons/location-dark.svg') : require('assets/icons/location.svg') } />
      <div className="clinic__info">
        <div className="type__address__location clinic__name">{name}</div>
        <div className="clinic__address">
          <div className="type__address clinic__address--ellipsis">{street}</div>
          <div className="type__address clinic__address--ellipsis">{`${city} ${state}`}</div>
        </div>
      </div>
    </div>
  );
}

export default class SelectClinic extends Component {
  static propTypes = {
    clinics: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        address: PropTypes.shape({
          street: PropTypes.string.isRequired,
          street2: PropTypes.string.isRequired,
          city: PropTypes.string.isRequired,
          state: PropTypes.string.isRequired,
          zip: PropTypes.string.isRequired,
        }).isRequired
      })
    )
  }

  static defaultProps = {
    clinics: []
  }

  render() {
    const { clinics, selected } = this.props;
    return (
      <div className="clinics">
        {clinics && clinics.map((clinic) => {
          const isSelected = selected && selected.id === clinic.id;
          return (
            <OptionButton key={clinic.id} className="clinic__option" isSelected={isSelected} onClick={() => this.props.onSelect(clinic)}>
              <ClinicButton clinic={clinic} isSelected={isSelected} />
            </OptionButton>
          );
        })}
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/SelectClinic/SelectClinic.js